document.addEventListener('DOMContentLoaded', function() {
    const btn = document.querySelector('.azioni-singolo-prodotto');
    let id_prodotto = btn.getAttribute('data-prodotto');
    let id_user = btn.getAttribute('data-user');
    let azione = btn.getAttribute('data-azione');
      const dataToSend = new FormData();
      dataToSend.append('azione','check');
      dataToSend.append('id_prodotto',id_prodotto);
      dataToSend.append('user',id_user);
      fetch('https://ar.19advdev.com/wishlist.php', {
        method: 'POST',
        body: dataToSend
      })
       .then(response => response.json())
       .then(data => {
          if(data.code==200){
             btn.classList.add('in-list');
             btn.setAttribute('data-azione','remove');
           }
       })
       .catch(error => console.error('Error:', error));

     btn.addEventListener('click',()=>{
      const dataToSend = new FormData();
      let azione = btn.getAttribute('data-azione');
      dataToSend.append('azione',azione);
      dataToSend.append('id_prodotto',id_prodotto);
      dataToSend.append('user',id_user);
      fetch('https://ar.19advdev.com/wishlist.php', {
        method: 'POST',
        body: dataToSend
      })
        .then(response => response.json())
        .then(data => {
            if(data.code==200){
              if(azione=='add'){
                btn.classList.add('in-list');
                btn.setAttribute('data-azione','remove');
                msg_wishlist('The item has been added to your wishlist');
              }else{
                btn.classList.remove('in-list');
                btn.setAttribute('data-azione','add');
                msg_wishlist('The item has been removed from your wishlist');
              }
            }
          })
          .catch(error => console.error('Error:', error));
     });  
    
});
